import FormStepper from "../../../../templates/src/Components/FormStepper/FormStepper";
import {gsap} from "gsap";
import CalculatorIntro from "./Calculator.intro";
import CalculatorExecution from "./Calulator.execution";
import CalculatorResults from "./Calculator.results";
import CalculatorEmail from "./Calculator.email";

const Calculator = {

    init() {
        this.el = $('[component="Calculator"]');
        this.calc = $('[module="forms"][form="Calculator"]');
        this.form = $('[module="forms"][form="CalculatorSend"]');
        if (!this.calc.length) return;

        this.holder = this.el.find('.holder');
        this.slides = this.calc.find('slide');
        this.forms = this.el.find('[module="forms"]');
        this.outcome = this.el.find('.outcome');
        this.bind();
        CalculatorIntro.init(this.el);
        CalculatorExecution.init(this.calc);
        CalculatorEmail.init(this.el);
        // if (FormStepperRouter.path.length === 1) this.resize();
    },

    bind() {
        this.calc.find('button.calc').click((evt) => {
            CalculatorEmail.fill();
            const btn = $(evt.currentTarget)
            btn.attr('load', '');

            setTimeout(() => {
                FormStepper.slide(1);
                btn.removeAttr('load');
                CalculatorResults.show();
            }, 1000)
        })

        this.calc.find('button.email').click(() => {
            FormStepper.slide(1);
        })
    },

    resize() {
        return;
        setTimeout(()=>{
            const height = this.forms.filter('.active').outerHeight();
            gsap.to(this.holder, {height: height})
        }, 1)

    },
}

export default Calculator;
